import {
    NinchatActionType,
    NinchatRegisterAudienceAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const registerAudience = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatRegisterAudienceAction}`,
    async (arg: NinchatActionParams<NinchatRegisterAudienceAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatRegisterAudienceAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
